<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<h1>{{ locale.translations['user']['user-verify']['n232'] }}</h1>

		<p *ngIf="type === '1'">
			{{ locale.translations['user']['user-verify']['n233'] }}
			<br />
			<span dir="ltr">{{ altPhone ? altPhone : auth.user()['phone'] }}</span>
		</p>

		<p *ngIf="type === '2'">
			{{ locale.translations['user']['user-verify']['n250'] }}
			<br />
			{{ auth.user()['email'] }}
		</p>

		<p>
			{{ locale.translations['user']['user-verify']['n234'] }}
		</p>
	</div>

	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" class="suffix" hideRequiredMarker>
						<mat-label>{{ locale.translations['user']['user-verify']['n235'] }}</mat-label>

						<input matInput required minlength="6" maxlength="6" (keypress)="isNumberKey($event)" (keyup)="onKeyUp('otp')" formControlName="otp" />

						<i class="fas fa-unlock-alt" [ngClass]="{ 'pos-ltr': locale.lang === 'en', 'pos-rtl': locale.lang !== 'en' }"></i>
					</mat-form-field>

					<span style="height: 2em; display: block">
						<a [routerLink]="['.']" [queryParams]="{ type: type === '2' ? 'email' : undefined }" (click)="resendOTP()" *ngIf="showResendOTP">
							{{ locale.translations['user']['user-verify']['n236'] }}
						</a>

						<span *ngIf="!showResendOTP" class="showResendOTPTimer">
							<div class="spinner preserve">
								<mat-progress-spinner mode="determinate" [value]="(showResendOTPTimer / 30) * 100" diameter="20"></mat-progress-spinner>
							</div>

							<span>{{ showResendOTPTimer }}</span>
						</span>
					</span>

					<span style="height: 2em; display: block" *ngIf="type === '1'">
						<a [routerLink]="['/user/' + auth.user()['userID'] + '/process']" [queryParams]="{ subject: 'incorrectPhone' }" *ngIf="showResendOTP">
							{{ locale.translations['user']['user-verify']['n240'] }}
						</a>
					</span>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<button mat-flat-button type="submit" color="primary" [disabled]="!form.valid || loading">
						{{ locale.translations['place-ad']['finish']['n77'] }}
					</button>
				</div>
			</div>
		</form>
	</div>
</div>
